/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import {
  createRef,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { MultiSelect } from "primereact/multiselect";
import { SignaturePadRef } from "../Add Risk Assessment/SignaturePadComponent";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import {
  fetchActivitiesList,
  fetchAllProjects,
  fetchKeyPlantsDetails,
  fetchUsersList,
  fetchVehicles,
} from "./fetchData";
import { Toast } from "primereact/toast";
import { dataURLToFile, getTodayDate } from "../helper/helperFunctions";
import TeamPhotoUpload from "../PhotoUpload";
// import PhotoUpload from "../Job Sheet Belfast/photoUpload";
import EmergencyDetails from "./EmergencyDetails";
import Signatures from "../Add Risk Assessment/Signatures";
import AddEquipmentform from "../Equipment Checklist form/AddEquipmentForm";
import RiskAssessmentAndControls from "./RiskAssessmentAndControls";
import AddPermitSpaceEntryForm from "../Permit Confined Space Entry Form/AddPermitSpaceEntryForm";
import AddConfinedSpacesEquipment from "../Confined Spaces Equipment form/AddConfinedSpacesEquipment";
import { defaultFormValues as defaultEnvironmentalFormValues } from "./defaultFormValues";
import { defaultFormValues as defaultConfinedSpaceFormvalues } from "../Confined Spaces Equipment form/defaultFormvalues";
import { defaultFormValues as defaultEquipmentChecklistValues } from "../Equipment Checklist form/defaultFormValues";
import { defaultFormValues as defaultPermitSpacesFormValues } from "../Permit Confined Space Entry Form/defaultFormValues";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import axios from "../../../../util/axiosconfig";
import {
  validateConfinedSpaceForm,
  validateEnvForm,
  validateEquipmentForm,
  validatePermitForm,
} from "./ValidateForms";
import { PermitSignatureContext } from "./PermitSignatureContext";
import { useNavigate } from "react-router-dom";
import PhotoUpload from "../Vehicle-assessment/PhotoUpload/photoUpload";

const AddEnvironmentalSurveying = () => {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const firstRef = useRef<SignaturePadRef | null>(null);
  const secondRef = useRef<SignaturePadRef | null>(null);
  const [additionalMemberRefs, setAdditionalMemberRefs] = useState<
    React.RefObject<SignaturePadRef>[]
  >([]);
  const [isUploadInProgress, setIsUploadInProgress] = useState(false);
  const [images, setImages] = useState<Record<string, File>>({});
  const [fileValues, setFileValues] = useState<any[]>([]);
  const [signatureDataURLs, setSignatureDataURLs] = useState<any>({
    firstRef: "",
    secondRef: "",
    additionalRefs: [],
  });

  const [envEntrantTopmans, setEnvEntrantTopmans] = useState<any>({
    teamMember1: {
      approvalOfPermit: null,
      permitClosure: null,
    },
    teamMember2: {
      approvalOfPermit: null,
      permitClosure: null,
    },
    additionalMembers: {
      approvalOfPermit: [],
      permitClosure: [],
    },
  });

  const [timeStampLocationValues, setTimeStampLocationValues] = useState({
    locations: [],
    timeStamps: [],
  });

  const [showEquipmentFormPopup, setShowEquipmentFormPopup] = useState(false);
  const [showConfinedSpaceFormPopup, setShowConfinedSpaceFormPopup] =
    useState(false);
  const [showPermitSpaceFormPopup, setShowPermitSpaceFormPopup] =
    useState(false);

  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [selectedTeamMember1, setSelectedTeamMember1] = useState<any>(null);
  const [selectedTeamMember2, setSelectedTeamMember2] = useState<any>(null);
  const [additionalTeamMember, setAdditionalTeamMember] = useState<any[]>([]);
  const [images1, setImages1] = useState<Record<string, File>>({});
  const [images2, setImages2] = useState<Record<string, File>>({});
  const [images3, setImages3] = useState<Record<string, File>>({});
  const [selectedAandE, setSelectedAandE] = useState<any>(null);
  const [selectedEmergencyContact, setSelectedEmergencyContact] =
    useState<any>(null);
  const [allActiveProjects, setAllActiveProjects] = useState<any[]>([]);
  const [vehiclesList, setVehiclesList] = useState<any[]>([]);
  const [usersList, setUsersList] = useState<any[]>([]);
  const [keyPlantsDetailsList, setKeyPlantsDetailsList] = useState<any[]>([]);
  const [activitiesList, setActivitiesList] = useState<any>([]);
  const [formSubmitting, setFormSubmitting] = useState(false);

  const [permitImages, setPermitImages] = useState<Record<string, File>>({});

  const context = useContext(PermitSignatureContext);

  if (!context) {
    throw new Error("FilterPage must be used within a FilterProvider");
  }

  const {
    permitApprovalRefs,
    permitClosureRefs,
    // permitSignatureDataUrl,
    setPermitSignatureDataUrl,
  } = context;

  const [permitFileValues, setPermitFileValues] = useState<any[]>([]);
  const [permitSignatureFiles, setPermitSignatureFiles] = useState<any>({
    approvalOfPermit: [],
    permitClosure: [],
  });
  const [permitTimeStampLocationValues, setPermitTimeStampLocationValues] =
    useState({
      locations: [],
      timeStamps: [],
    });

  const [selectedDescriptionOfSurveySite, setSelectedDescriptionOfSurveySite] =
    useState<any>(null);
  const [selectedPermitClosureReason, setSelectedPermitClosureReason] =
    useState<any>(null);
  const [selectedPurposeOfEntry, setSelectedPurposeOfEntry] =
    useState<any>(null);
  const [selectedNames, setSelectedNames] = useState<any[]>([]);
  const [permitStartDateTime, setPermitStartDateTime] = useState<any>(null);
  const [permitEndDateTime, setPermitEndDateTime] = useState<any>(null);

  const [formValues, setFormValues] = useState<any>(
    defaultEnvironmentalFormValues
  );

  const [addEquipmentFormValues, setAddEquipmentFormValues] = useState<any>(
    defaultEquipmentChecklistValues
  );
  const [isEquipmentFormAttached, setIsEquipmentFormAttached] =
    useState<boolean>(false);

  const [
    addConfinedSpacesEquipmentFormValues,
    setAddConfinedSpacesEquipmentFormValues,
  ] = useState<any>(defaultConfinedSpaceFormvalues);
  const [confinedSpaceFileValues, setConfinedSpaceFileValues] = useState<any[]>(
    []
  );
  const [confinedImages, setConfinedImages] = useState<Record<string, File>>(
    {}
  );

  const [confinedSpaceTimeStampValues, setConfinedSpaceTimeStampValues] =
    useState<any[]>([]);
  const [isConfinedSpaceFormAttached, setIsConfinedSpaceFormAttached] =
    useState<boolean>(false);

  const [addPermitSpaceFormValues, setAddPermitSpaceFormValues] = useState<any>(
    defaultPermitSpacesFormValues
  );

  const [permitSpaceFileValues, setPermitSpaceFileValues] = useState<any[]>([]);
  const [isPermitSpaceFormAttached, setIsPermitSpaceFormAttached] =
    useState<boolean>(false);

  const isDisabled = isUploadInProgress || formSubmitting;

  const allEnvUSers = [
    ...(formValues.teamMember1?.userID ? [formValues.teamMember1] : []),
    ...(formValues.teamMember2?.userID ? [formValues.teamMember2] : []),
    ...formValues.additionalTeamMembers,
  ];

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Function to clear all signatures
  const clearAllSignatures = useCallback(() => {
    // Don't clear signatures on initial load
    if (isInitialLoad) return;

    // Clear client signature
    if (firstRef.current) {
      firstRef.current.clear();
    }

    if (secondRef.current) {
      secondRef.current.clear();
    }

    // Clear all staff member signatures
    additionalMemberRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.clear();
      }
    });
  }, [
    formValues?.teamMember1,
    formValues?.teamMember2,
    formValues?.additionalTeamMembers,
    isInitialLoad,
  ]);

  // Create a more specific dependency that excludes confinedSpaceEntryPermit
  const checklistStringWithoutConfinedSpace = useMemo(() => {
    const filteredChecklist =
      formValues?.startWorkAssessment?.checklist?.filter(
        (item: any) => item.name !== "confinedSpaceEntryPermit"
      ) || [];
    return JSON.stringify(filteredChecklist);
  }, [formValues?.startWorkAssessment?.checklist]);

  // Clear signatures when form values change
  useEffect(() => {
    clearAllSignatures();
  }, [
    formValues?.projectKeyName,
    formValues?.location,
    formValues?.vehicleRegistration,
    formValues?.teamMember1?.userID,
    formValues?.teamMember2?.userID,
    formValues?.additionalTeamMembers,
    formValues?.keyPlantDetails,
    formValues?.activity,
    formValues?.emergencyDetails?.aAndE,
    formValues?.emergencyDetails?.others,
    formValues?.emergencyDetails?.emergencyContact,
    formValues?.emergencyDetails?.isFirstAiderAvailable,
    formValues?.emergencyDetails?.isFirstAidKitAvailable,
    checklistStringWithoutConfinedSpace,
    formValues?.startWorkAssessment?.riskelements,
    clearAllSignatures,
  ]);

  // Clear signatures when photos change
  useEffect(() => {
    clearAllSignatures();
  }, [fileValues, clearAllSignatures]);

  useEffect(() => {
    fetchAllProjects(setAllActiveProjects, toast);
    fetchVehicles(setVehiclesList, toast);
    fetchUsersList(setUsersList, toast);
    fetchKeyPlantsDetails(setKeyPlantsDetailsList, toast);
    fetchActivitiesList(setActivitiesList, toast);
  }, []);

  useEffect(() => {
    const updateSignatureDataURLs = () => {
      setSignatureDataURLs({
        firstRef: firstRef.current?.toDataURL() || "",
        secondRef: secondRef.current?.toDataURL() || "",
        additionalRefs: additionalMemberRefs.map(
          (ref) => ref.current?.toDataURL() || ""
        ),
      });
    };

    if (
      formValues?.startWorkAssessment.checklist.find(
        (item: any) => item.name === "confinedSpaceEntryPermit"
      ).value === true
    ) {
      updateSignatureDataURLs();
    }
    setIsInitialLoad(false);
  }, [formValues?.startWorkAssessment.checklist, additionalMemberRefs]);

  useEffect(() => {
    setAdditionalMemberRefs((prevRefs) => {
      const newRefs = [...prevRefs];
      while (newRefs.length < formValues.additionalTeamMembers.length) {
        newRefs.push(createRef<any>());
      }
      while (newRefs.length > formValues.additionalTeamMembers.length) {
        newRefs.pop();
      }
      return newRefs;
    });
  }, [formValues.additionalTeamMembers.length]);

  const projectKeyNameOptionsTemplate = (option: any) => {
    return (
      <div>
        {option.projectKey} - {option.name}
      </div>
    );
  };

  const projectKeyNameValueTemplate = (option: any) => {
    if (!option) {
      return "Select Project Key and Name";
    }
    return (
      <div>
        {option.projectKey} - {option.name}
      </div>
    );
  };

  const cleanupUserData = (userId: string, type?: string) => {
    if (!userId) return;

    if (type === "teamMember1") {
      setImages1({});
    } else if (type === "teamMember2") {
      setImages2({});
    }
    if (images1[userId]) {
      const newImages1 = { ...images1 };
      delete newImages1[userId];
      setImages1(newImages1);
    }
    if (images2[userId]) {
      const newImages2 = { ...images2 };
      delete newImages2[userId];
      setImages2(newImages2);
    }
    if (images3[userId]) {
      const newImages3 = { ...images3 };
      delete newImages3[userId];
      setImages3(newImages3);
    }

    setFileValues((prev: any[]) =>
      prev.filter((item) => item.userID !== userId)
    );

    setTimeStampLocationValues((prev: any) => ({
      locations: prev.locations.filter((loc: any) => loc.userID !== userId),
      timeStamps: prev.timeStamps.filter((ts: any) => ts.userID !== userId),
    }));
  };

  const handleTeamMember1Change = (e: any) => {
    if (selectedTeamMember1?.userID) {
      cleanupUserData(selectedTeamMember1.userID, "teamMember1");
    }

    setFormValues((prev: any) => ({
      ...prev,
      teamMember1: {
        ...prev.teamMember1,
        userID: e.value.userID,
        displayName: e.value.displayName,
        photo: null,
      },
    }));
    setSelectedTeamMember1(e.value);
  };

  const handleTeamMember2Change = (e: any) => {
    if (selectedTeamMember2?.userID) {
      cleanupUserData(selectedTeamMember2.userID, "teamMember2");
    }

    setFormValues((prev: any) => ({
      ...prev,
      teamMember2: {
        ...prev.teamMember2,
        userID: e.value.userID,
        displayName: e.value.displayName,
        photo: null,
      },
    }));
    setSelectedTeamMember2(e.value);
  };
  const handleAdditionalTeamMembersChange = (e: any) => {
    const removedMembers = additionalTeamMember.filter(
      (prevMember: any) =>
        !e.value.some((current: any) => current.userID === prevMember.userID)
    );

    removedMembers.forEach((member: any) => {
      cleanupUserData(member.userID);
    });

    setFormValues((prev: any) => ({
      ...prev,
      additionalTeamMembers: e.value.map((member: any) => ({
        ...member,
        photo: null,
      })),
    }));
    setAdditionalTeamMember(e.value);
  };

  const handleSave = async () => {
    try {
      if (
        !validateEnvForm(
          formValues,
          fileValues,
          firstRef,
          secondRef,
          additionalMemberRefs,
          isPermitSpaceFormAttached,
          envEntrantTopmans,
          toast
        )
      ) {
        return;
      }
      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "preUseInspection"
        ).value === true &&
        !isEquipmentFormAttached &&
        !validateEquipmentForm(addEquipmentFormValues, toast)
      ) {
        return;
      }

      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "confinedSpaceEntryTraining"
        ).value === true &&
        !isConfinedSpaceFormAttached &&
        !validateConfinedSpaceForm(
          addConfinedSpacesEquipmentFormValues,
          confinedSpaceFileValues,
          toast
        )
      ) {
        return;
      }

      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "confinedSpaceEntryPermit"
        ).value === true &&
        !isPermitSpaceFormAttached &&
        !validatePermitForm(
          addPermitSpaceFormValues,
          permitFileValues,
          permitApprovalRefs,
          permitClosureRefs,
          permitSignatureFiles,
          allEnvUSers,
          toast
        )
      ) {
        return;
      }
      setFormSubmitting(true);
      setIsUploadInProgress && setIsUploadInProgress(true);
      const formData = new FormData();

      const teamPhotos: File[] = [];
      const vanPhotos: File[] = [];
      const envSignatures: File[] = [];
      const equipmentPhotos: File[] = [];
      const siteSetupPhotos: File[] = [];

      if (
        firstRef.current &&
        !firstRef.current.isEmpty() &&
        formValues.teamMember1.userID
      ) {
        const signatureDataUrl = firstRef.current.toDataURL();
        const signatureFile = dataURLToFile(
          signatureDataUrl,
          `${formValues.teamMember1.userID}_sig.png`
        );
        if (signatureFile) {
          envSignatures.push(signatureFile);
        }
      }

      if (
        secondRef.current &&
        !secondRef.current.isEmpty() &&
        formValues.teamMember2.userID
      ) {
        const signatureDataUrl = secondRef.current.toDataURL();
        const signatureFile = dataURLToFile(
          signatureDataUrl,
          `${formValues.teamMember2.userID}_sig.png`
        );
        if (signatureFile) {
          envSignatures.push(signatureFile);
        }
      }

      formValues.additionalTeamMembers.forEach((member: any, index: number) => {
        const ref = additionalMemberRefs[index];
        if (ref.current && !ref.current.isEmpty() && member.userID) {
          const signatureDataUrl = ref.current.toDataURL();
          const signatureFile = dataURLToFile(
            signatureDataUrl,
            `${member.userID}_sig.png`
          );
          if (signatureFile) {
            envSignatures.push(signatureFile);
          }
        }
      });
      // Add all signatures to FormData
      envSignatures.forEach((file, index) => {
        formData.append(`envSignatures`, file);
      });

      // Process photos from fileValues.photo
      fileValues.forEach((photoItem: any) => {
        if (photoItem.photoKey && photoItem?.file) {
          const fileName = `${photoItem.photoKey}.png`;
          const dataURL = new Blob([photoItem?.file], {
            type: "image/png",
          });
          // Convert Blob to File
          const photoFile = new File([dataURL], fileName, {
            type: "image/png",
          });
          vanPhotos.push(photoFile);
        }
      });
      vanPhotos.forEach((file, index) => {
        formData.append(`vanPhotos`, file);
      });
      // 2. Process profile images

      // Process photos from fileValues.photo
      fileValues.forEach((photoItem: any) => {
        if (photoItem.userID && photoItem.images?.default) {
          const fileName = `${photoItem.userID}_photo.png`;
          const dataURL = new Blob([photoItem.images.default], {
            type: "image/png",
          });
          // Convert Blob to File
          const photoFile = new File([dataURL], fileName, {
            type: "image/png",
          });
          teamPhotos.push(photoFile);

          // Update the photo reference in formValues
          if (formValues.teamMember1.userID === photoItem.userID) {
            formValues.teamMember1.photo = fileName;
          } else if (formValues.teamMember2.userID === photoItem.userID) {
            formValues.teamMember2.photo = fileName;
          } else {
            const additionalMember = formValues.additionalTeamMembers.find(
              (m: any) => m.userID === photoItem.userID
            );
            if (additionalMember) {
              additionalMember.photo = fileName;
            }
          }
        }
      });
      teamPhotos.forEach((file, index) => {
        formData.append(`teamPhotos`, file);
      });

      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "confinedSpaceEntryTraining"
        ).value === true &&
        !isConfinedSpaceFormAttached
      ) {
        confinedSpaceFileValues.forEach((photoItem: any) => {
          if (photoItem.photoKey && photoItem?.file) {
            const fileName = `${photoItem.photoKey}-1.png`;
            const dataURL = new Blob([photoItem?.file], {
              type: "image/png",
            });
            const photoFile = new File([dataURL], fileName, {
              type: "image/png",
            });
            equipmentPhotos.push(photoFile);
          }
        });
      }
      equipmentPhotos.forEach((file, index) => {
        formData.append(`equipmentPhotos`, file);
      });

      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "confinedSpaceEntryPermit"
        ).value === true &&
        !isPermitSpaceFormAttached
      ) {
        const allEnvUsers = [
          ...(formValues.teamMember1?.userID ? [formValues.teamMember1] : []),
          ...(formValues.teamMember2?.userID ? [formValues.teamMember2] : []),
          ...formValues.additionalTeamMembers,
        ];

        // Find users present in both allEnvUsers and permitFileValues
        // const commonEnvPermitUsers = addPermitSpaceFormValues.name.filter(
        //   (user: any) =>
        //     allEnvUsers.some(
        //       (photoItem: any) => photoItem.userID === user.userID
        //     )
        // );

        // Get all refs for team members
        const allEnvRefs: React.RefObject<SignaturePadRef>[] = [
          ...(formValues.teamMember1?.userID ? [firstRef] : []),
          ...(formValues.teamMember2?.userID ? [secondRef] : []),
          ...additionalMemberRefs,
        ];

        // Attach signatures for users present in both lists
        allEnvUSers.forEach((member: any) => {
          const refIndex = allEnvUsers.findIndex(
            (u: any) => u.userID === member.userID
          );
          const ref = allEnvRefs[refIndex];
          if (ref?.current && !ref.current.isEmpty() && member.userID) {
            const signatureDataUrl = ref.current.toDataURL();
            const approvalSigNatureFile = dataURLToFile(
              signatureDataUrl,
              `${member.userID}_sig_approval.png`
            );
            const closureSigNatureFile = dataURLToFile(
              signatureDataUrl,
              `${member.userID}_sig_closure.png`
            );
            if (approvalSigNatureFile) {
              formData.append(`signatures`, approvalSigNatureFile);
              formData.append(`signatures`, closureSigNatureFile);
              // permitSignatureFiles.approvalOfPermit.push(signatureFile);
              // permitSignatureFiles.permitClosure.push(signatureFile);
            }
          }
        });

        permitFileValues.forEach((photoItem: any) => {
          if (photoItem.photoKey && photoItem?.file) {
            const fileName = `${photoItem.photoKey}.png`;
            const dataURL = new Blob([photoItem?.file], {
              type: "image/png",
            });
            const photoFile = new File([dataURL], fileName, {
              type: "image/png",
            });
            siteSetupPhotos.push(photoFile);
          }
        });
        siteSetupPhotos.forEach((file, index) => {
          formData.append(`siteSetupPhotos`, file);
        });
        permitSignatureFiles.approvalOfPermit.forEach((item: any) => {
          formData.append(`signatures`, item.sigFile);
        });
        permitSignatureFiles.permitClosure.forEach((item: any) => {
          formData.append(`signatures`, item.sigFile);
        });
      }

      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "confinedSpaceEntryPermit"
        ).value === true
      ) {
        setFormValues((prev: any) => ({
          ...prev,
          envEntrantTopmans,
        }));
      }

      formData.append("formJson", JSON.stringify(formValues));
      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "preUseInspection"
        ).value === true &&
        !isEquipmentFormAttached
      ) {
        formData.append(
          "preUseEquipmentFormJson",
          JSON.stringify(addEquipmentFormValues)
        );
      }
      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "confinedSpaceEntryTraining"
        ).value === true
      ) {
        formData.append(
          "confinedSpacesFormJson",
          JSON.stringify(addConfinedSpacesEquipmentFormValues)
        );
      }
      if (
        formValues?.startWorkAssessment?.checklist.find(
          (item: any) => item.name === "confinedSpaceEntryPermit"
        ).value === true &&
        !isPermitSpaceFormAttached
      ) {
        const permitJSon = addPermitSpaceFormValues;
        // Add users from allEnvUSers that are not already in permitJSon.name
        const existingUserIDs = permitJSon.name.map((u: any) => u.userID);
        allEnvUSers.forEach((user: any) => {
          if (!existingUserIDs.includes(user.userID)) {
            permitJSon.name.push(user);
          }
        });
        formData.append("permitSpacesFormJson", JSON.stringify(permitJSon));
      }
      formData.append(
        "timeStampLocationJson",
        JSON.stringify(timeStampLocationValues)
      );
      formData.append("isWeb", "true");

      const response = await axios.post(
        "health-and-safety/daily-risk-assessment-survey-form ",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFormSubmitting(false);
      showSuccess(response.data.Message, toast);
      setIsUploadInProgress && setIsUploadInProgress(false);
      navigate("/layout/health-and-safety/environment-surveying");
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setIsUploadInProgress && setIsUploadInProgress(false);
      setFormSubmitting(false);
      showError(errorMessage, toast);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg tw-relative tw-bg-white tw-mx-2 sm:tw-mx-4 lg:tw-mx-0">
        <div className="tw-bg-[#F8FAFC] tw-p-3 sm:tw-p-4 lg:tw-p-6 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
          <h2 className="tw-text-base sm:tw-text-lg md:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-[#101828] tw-leading-tight">
            DAILY DYNAMIC RISK ASSESSMENT – ENVIRONMENTAL SURVEYING
          </h2>
        </div>
        <div>
          <div className="tw-p-3 sm:tw-p-4 lg:tw-p-6">
            <div className="tw-pt-2 sm:tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0]">
              <h2 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-[#101828]">
                Part 1: Basic Details
              </h2>
            </div>
            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 xl:tw-grid-cols-3  tw-gap-4 sm:tw-gap-6 tw-w-full tw-mt-4">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label
                  className="leak-label tw-text-sm sm:tw-text-base"
                  htmlFor="teamMember1"
                >
                  Project Name & Project Key
                </label>
                <Dropdown
                  id="projectName"
                  placeholder="Select a Project Key and Name"
                  value={selectedProject ?? null}
                  onChange={(e) => {
                    setSelectedProject(e.value);
                    setFormValues((prev: any) => ({
                      ...prev,
                      projectKeyName: `${e.value?.projectKey} - ${e.value?.name}`,
                    }));
                    setAddPermitSpaceFormValues((prev: any) => ({
                      ...prev,
                      project: `${e.value?.projectKey} - ${e.value?.name}`,
                    }));
                  }}
                  options={allActiveProjects}
                  itemTemplate={projectKeyNameOptionsTemplate}
                  valueTemplate={projectKeyNameValueTemplate}
                  filterBy="projectKey,name"
                  filterMatchMode="contains"
                  filter
                  disabled={isDisabled}
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-10 sm:tw-h-11 tw-w-full tw-text-sm sm:tw-text-base"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label
                  className="leak-label tw-text-sm sm:tw-text-base"
                  htmlFor="teamMember1"
                >
                  Date
                </label>
                <InputText
                  value={getTodayDate()}
                  readOnly
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-10 sm:tw-h-11 tw-w-full tw-text-sm sm:tw-text-base"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label
                  className="leak-label tw-text-sm sm:tw-text-base"
                  htmlFor="teamMember1"
                >
                  Location
                </label>
                <InputText
                  value={formValues.location || ""}
                  onChange={(e) =>
                    setFormValues((prev: any) => ({
                      ...prev,
                      location: e.target.value,
                    }))
                  }
                  disabled={isDisabled}
                  placeholder="Enter Location"
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-10 sm:tw-h-11 tw-w-full tw-text-sm sm:tw-text-base"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label
                  className="leak-label tw-text-sm sm:tw-text-base"
                  htmlFor="teamMember1"
                >
                  Vehicle Registration
                </label>
                <Dropdown
                  id="projectName"
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-10 sm:tw-h-11 tw-w-full tw-text-sm sm:tw-text-base"
                  value={selectedVehicle ?? null}
                  onChange={(e) => {
                    setSelectedVehicle(e.value);
                    setFormValues((prev: any) => ({
                      ...prev,
                      vehicleRegistration: e.value?.registration_no,
                    }));
                  }}
                  disabled={isDisabled}
                  options={vehiclesList}
                  optionLabel="registration_no"
                  placeholder="Select a Vehicle Registration"
                  filter
                />
              </div>
            </div>

            {/* Team Members Section - Mobile Responsive */}
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-3 tw-justify-start tw-gap-4 lg:tw-gap-8 tw-my-4 tw-items-start tw-w-full">
              {/* Team Member 1 */}
              <div className="tw-flex tw-flex-col tw-gap-4 tw-w-full lg:tw-w-auto">
                <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                  <label
                    className="leak-label tw-text-sm sm:tw-text-base"
                    htmlFor="teamMember1"
                  >
                    Team Member 1
                  </label>
                  <Dropdown
                    id="teamMember1"
                    optionLabel="displayName"
                    placeholder="Select Team Member 1"
                    disabled={isDisabled}
                    value={selectedTeamMember1}
                    onChange={handleTeamMember1Change}
                    options={
                      usersList.filter(
                        (member: any) =>
                          member.userID !== selectedTeamMember2?.userID &&
                          !additionalTeamMember.some(
                            (additional: any) =>
                              additional.userID === member.userID
                          )
                      ) ?? []
                    }
                    filter
                    className="custome-dropdown !tw-w-full tw-h-10 sm:tw-h-11 tw-text-sm sm:tw-text-base"
                  />
                </div>
                <TeamPhotoUpload
                  label="Photo of Team Member 1 in PPE"
                  images={images1}
                  isUploadInProgress={isDisabled}
                  setIsUploadInProgress={setIsUploadInProgress}
                  setImages={setImages1}
                  formValues={formValues}
                  setFormValues={setFormValues}
                  fileValues={fileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  setFileValues={setFileValues}
                  classname="tw-w-full"
                  maxImages={selectedTeamMember1 ? 1 : 0}
                  type="teamMember1"
                />
              </div>

              {/* Team Member 2 */}
              <div className="tw-flex tw-flex-col tw-gap-4 tw-w-full lg:tw-w-auto ">
                <div className="tw-flex tw-flex-col tw-gap-1 ">
                  <label
                    className="leak-label tw-text-sm sm:tw-text-base"
                    htmlFor="teamnMember2"
                  >
                    Team Member 2
                  </label>
                  <Dropdown
                    id="teamnMember2"
                    optionLabel="displayName"
                    placeholder="Select Team Member 2"
                    value={selectedTeamMember2}
                    disabled={isDisabled}
                    onChange={handleTeamMember2Change}
                    options={
                      usersList.filter(
                        (member: any) =>
                          member.userID !== selectedTeamMember1?.userID &&
                          !additionalTeamMember.some(
                            (additional: any) =>
                              additional.userID === member.userID
                          )
                      ) ?? []
                    }
                    filter
                    className="custome-dropdown !tw-w-full tw-h-10 sm:tw-h-11 tw-text-sm sm:tw-text-base"
                  />
                </div>
                <TeamPhotoUpload
                  label="Photo of Team Member 2 in PPE"
                  images={images2}
                  isUploadInProgress={isDisabled}
                  setIsUploadInProgress={setIsUploadInProgress}
                  setImages={setImages2}
                  formValues={formValues}
                  setFormValues={setFormValues}
                  fileValues={fileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  setFileValues={setFileValues}
                  classname="tw-w-full"
                  maxImages={selectedTeamMember2 ? 1 : 0}
                  type="teamMember2"
                />
              </div>

              {/* Additional Team Members */}
              <div className="tw-flex tw-flex-col tw-gap-4 tw-w-full lg:tw-w-auto ">
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <label
                    className="leak-label tw-text-sm sm:tw-text-base"
                    htmlFor="addteamname"
                  >
                    Additional Team Member If Any
                  </label>
                  <MultiSelect
                    id="addteamname"
                    optionLabel="displayName"
                    maxSelectedLabels={2}
                    disabled={isDisabled}
                    selectAllLabel="Select All"
                    placeholder="Select Additional Member"
                    value={additionalTeamMember}
                    onChange={handleAdditionalTeamMembersChange}
                    options={
                      usersList.filter(
                        (member: any) =>
                          member.userID !== selectedTeamMember1?.userID &&
                          member.userID !== selectedTeamMember2?.userID
                      ) ?? []
                    }
                    filter
                    className="custome-multiselect !tw-w-full tw-h-10 sm:tw-h-11 tw-text-sm sm:tw-text-base"
                  />
                </div>
                <TeamPhotoUpload
                  label="Photo of any additional team member in PPE"
                  images={images3}
                  isUploadInProgress={isDisabled}
                  setIsUploadInProgress={setIsUploadInProgress}
                  setImages={setImages3}
                  formValues={formValues}
                  setFormValues={setFormValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  fileValues={fileValues}
                  setFileValues={setFileValues}
                  classname="tw-w-full"
                  maxImages={
                    additionalTeamMember?.length > 0
                      ? additionalTeamMember.length
                      : 0
                  }
                  type="additionalTeamMember"
                />
              </div>
            </div>

            {/* Van Photos and Plant Details Section */}
            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-4 sm:tw-gap-6 tw-w-full tw-mt-6">
              <div className="tw-flex tw-flex-col tw-gap-4">
                {/* <PhotoUpload
                  label={
                    <span>
                      Photo of Van at the Start of the Day (2 photos){" "}
                      <span className="tw-text-red-500">*</span>
                    </span>
                  }
                  name="van_photo"
                  images={images}
                  isUploadInProgress={isDisabled}
                  setIsUploadInProgress={setIsUploadInProgress}
                  setImages={setImages}
                  fileValues={fileValues}
                  setFileValues={setFileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  classname="tw-w-full"
                  maxImages={2}
                /> */}
                <PhotoUpload
                  label={
                    <span>
                      Photo of Van at the Start of the Day (Photo 1){" "}
                      <span className="tw-text-red-500">*</span>
                    </span>
                  }
                  name="van_photo-1"
                  images={images}
                  isUploadInProgress={isDisabled}
                  setIsUploadInProgress={setIsUploadInProgress}
                  setImages={setImages}
                  fileValues={fileValues}
                  setFileValues={setFileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  classname="tw-w-full"
                />
              </div>

              <div className="tw-flex tw-flex-col tw-gap-4">
                <PhotoUpload
                  label={
                    <span>
                      Photo of Van at the Start of the Day (Photo 2){" "}
                      <span className="tw-text-red-500">*</span>
                    </span>
                  }
                  name="van_photo-2"
                  images={images}
                  isUploadInProgress={isDisabled}
                  setIsUploadInProgress={setIsUploadInProgress}
                  setImages={setImages}
                  fileValues={fileValues}
                  setFileValues={setFileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  classname="tw-w-full"
                />
              </div>

              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-w-full">
                <label
                  className="leak-label tw-text-sm sm:tw-text-base tw-font-medium tw-text-gray-700"
                  htmlFor="keyPlantDetails"
                >
                  Key Plant Details
                </label>
                <MultiSelect
                  id="keyPlantDetails"
                  selectAllLabel="Select All"
                  maxSelectedLabels={2}
                  placeholder="Select Key Plant"
                  optionLabel="name"
                  disabled={isDisabled}
                  value={formValues?.keyPlantDetails ?? ""}
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      keyPlantDetails: e.value,
                    }));
                  }}
                  filter
                  options={keyPlantsDetailsList}
                  className="custome-dropdown !tw-w-full tw-h-10 sm:tw-h-11"
                />
              </div>

              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-w-full">
                <label
                  className="leak-label tw-text-sm sm:tw-text-base tw-font-medium tw-text-gray-700"
                  htmlFor="activity"
                >
                  Activity
                </label>
                <MultiSelect
                  id="activity"
                  selectAllLabel="Select All"
                  maxSelectedLabels={2}
                  placeholder="Select Activity"
                  optionLabel="name"
                  disabled={isDisabled}
                  value={formValues?.activity ?? ""}
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      activity: e.value,
                    }));
                  }}
                  filter
                  options={activitiesList}
                  className="custome-dropdown !tw-w-full tw-h-10 sm:tw-h-11"
                />
              </div>
            </div>
            <div></div>
          </div>
          <div className="tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0]  ">
            <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
              Emergency Details
            </h2>
          </div>
          <EmergencyDetails
            toast={toast}
            isUploadInProgress={isDisabled}
            setIsUploadInProgress={setIsUploadInProgress}
            selectedAandE={selectedAandE}
            setSelectedAandE={setSelectedAandE}
            selectedEmergencyContact={selectedEmergencyContact}
            setSelectedEmergencyContact={setSelectedEmergencyContact}
            formValues={formValues}
            setFormValues={setFormValues}
          />

          <div className="tw-pt-4 tw-pb-2  tw-px-4 tw-border-b-[1px] tw-border-[#E2E8F0] tw-mt-6">
            <h2 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-[#101828]">
              Part 3: Risk Assessment and Controls
            </h2>
          </div>

          <RiskAssessmentAndControls
            toast={toast}
            isUploadInProgress={isDisabled}
            setIsUploadInProgress={setIsUploadInProgress}
            formValues={formValues}
            setFormValues={setFormValues}
            setShowEquipmentFormPopup={setShowEquipmentFormPopup}
            setShowConfinedSpaceFormPopup={setShowConfinedSpaceFormPopup}
            setShowPermitSpaceFormPopup={setShowPermitSpaceFormPopup}
            setAddEquipmentFormValues={setAddEquipmentFormValues}
            setAddConfinedSpacesEquipmentFormValues={
              setAddConfinedSpacesEquipmentFormValues
            }
            setAddPermitSpaceFormValues={setAddPermitSpaceFormValues}
            setIsEquipmentFormAttached={setIsEquipmentFormAttached}
            setIsConfinedSpaceFormAttached={setIsConfinedSpaceFormAttached}
            setIsPermitSpaceFormAttached={setIsPermitSpaceFormAttached}
            setConfinedSpaceFileValues={setConfinedSpaceFileValues}
            setConfinedSpaceTimeStampValues={setConfinedSpaceTimeStampValues}
            setPermitSpaceFileValues={setPermitSpaceFileValues}
            setPermitSpaceTimeStampValues={setPermitTimeStampLocationValues}
            setSignatureDataURLs={setSignatureDataURLs}
            firstRef={firstRef}
            secondRef={secondRef}
            additionalMemberRefs={additionalMemberRefs}
            setSelectedNames={setSelectedNames}
            setSelectedDescriptionOfSurveySite={
              setSelectedDescriptionOfSurveySite
            }
            setSelectedPurposeOfEntry={setSelectedPurposeOfEntry}
            setSelectedPermitClosureReason={setSelectedPermitClosureReason}
          />
          {formValues?.teamMember1?.userID && (
            <Signatures
              additionalTeamMembers={formValues.additionalTeamMembers}
              formValues={formValues}
              setFormValues={setFormValues}
              firstRef={firstRef}
              secondRef={secondRef}
              additionalMemberRefs={additionalMemberRefs}
            />
          )}
          <div className="tw-mt-6 tw-px-4 tw-pb-4">
            <p className="tw-text-xs sm:tw-text-sm tw-text-[#667085] tw-leading-relaxed">
              Note: In the event of any accidents/incidents, near miss or
              observations (good or bad) made during the shift please notify the
              project manager and health and safety manager.
            </p>
          </div>
        </div>
        <div className="tw-flex tw-justify-end tw-items-center tw-p-4  tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
          <Button
            className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-border-solid tw-border focus:tw-shadow-none  !tw-border-[#344054] tw-text-[#344054] tw-font-medium"
            label="Cancel"
            onClick={() => window.history.back()}
            color="white"
          />
          <Button
            className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium"
            label={`${formSubmitting ? "Saving..." : "Save"}`}
            loading={formSubmitting}
            disabled={isUploadInProgress}
            onClick={handleSave}
          />
        </div>
      </div>

      {/* Equipment Form Popup */}
      <Dialog
        header="Equipment Pre-Use Inspection Form"
        visible={showEquipmentFormPopup}
        onHide={() => setShowEquipmentFormPopup(false)}
        modal
        className="tw-w-[90vw] tw-max-w-4xl"
        draggable={false}
        resizable={true}
      >
        <AddEquipmentform
          formValues={addEquipmentFormValues}
          setFormValues={setAddEquipmentFormValues}
          isUploadInProgress={isUploadInProgress}
          isEquipmentFormAttached={isEquipmentFormAttached}
        />
      </Dialog>

      {/* Confined Space Form Popup */}
      <Dialog
        header="Confined Space Form"
        visible={showConfinedSpaceFormPopup}
        onHide={() => setShowConfinedSpaceFormPopup(false)}
        modal
        className="tw-w-[1220px]"
        draggable={false}
        resizable={true}
      >
        <AddConfinedSpacesEquipment
          formValues={addConfinedSpacesEquipmentFormValues}
          setFormValues={setAddConfinedSpacesEquipmentFormValues}
          setShowConfinedSpaceFormPopup={setShowConfinedSpaceFormPopup}
          isUploadInProgress={isUploadInProgress}
          isConfinedSpaceFormAttached={isConfinedSpaceFormAttached}
          showAttachedFiles={confinedSpaceFileValues}
          fileValues={confinedSpaceFileValues}
          setFileValues={setConfinedSpaceFileValues}
          showTimeStampLocations={confinedSpaceTimeStampValues}
          confinedImages={confinedImages}
          setConfinedImages={setConfinedImages}
        />
      </Dialog>

      {/* Permit Space Form Popup */}
      <Dialog
        header="Permit for Confined Space Entry"
        visible={showPermitSpaceFormPopup}
        onHide={() => {
          // Remove signatures for users that are no longer present
          setPermitSignatureFiles((prev: any) => ({
            approvalOfPermit: prev.approvalOfPermit.filter((item: any) =>
              addPermitSpaceFormValues.name.some(
                (member: any) => member.userID === item.userID
              )
            ),
            permitClosure: prev.permitClosure.filter((item: any) =>
              addPermitSpaceFormValues.name.some(
                (member: any) => member.userID === item.userID
              )
            ),
          }));

          // OnlyPermitUser: users present in addPermitSpaceFormValues.name but NOT in allEnvUSers
          const onlyPermitUser = addPermitSpaceFormValues.name.filter(
            (user: any) => {
              return !allEnvUSers.some(
                (envUser: any) => envUser.userID === user.userID
              );
            }
          );

          onlyPermitUser.forEach((member: any, index: number) => {
            const approvalRef = permitApprovalRefs[index];
            const closureRef = permitClosureRefs[index];

            // Approval signature
            if (
              approvalRef.current &&
              !approvalRef.current.isEmpty() &&
              member.userID
            ) {
              setPermitSignatureFiles((prev: any) => {
                // Check if userID already exists
                if (
                  prev.approvalOfPermit.some(
                    (item: any) => item.userID === member.userID
                  )
                ) {
                  return prev;
                }
                const signatureDataUrl = approvalRef.current.toDataURL();
                const signatureFile = dataURLToFile(
                  signatureDataUrl,
                  `${member.userID}_sig_approval.png`
                );
                if (signatureFile) {
                  return {
                    ...prev,
                    approvalOfPermit: [
                      ...prev.approvalOfPermit,
                      {
                        userID: member.userID,
                        sigFile: signatureFile,
                      },
                    ],
                  };
                }
                return prev;
              });
            }

            // Closure signature
            if (
              closureRef.current &&
              !closureRef.current.isEmpty() &&
              member.userID
            ) {
              setPermitSignatureFiles((prev: any) => {
                // Check if userID already exists
                if (
                  prev.permitClosure.some(
                    (item: any) => item.userID === member.userID
                  )
                ) {
                  return prev;
                }
                const signatureDataUrl = closureRef.current.toDataURL();
                const signatureFile = dataURLToFile(
                  signatureDataUrl,
                  `${member.userID}_sig_closure.png`
                );
                if (signatureFile) {
                  return {
                    ...prev,
                    permitClosure: [
                      ...prev.permitClosure,
                      {
                        userID: member.userID,
                        sigFile: signatureFile,
                      },
                    ],
                  };
                }
                return prev;
              });
            }
          });

          // Prevent duplicate signatures by userID
          if (permitApprovalRefs.length > 0) {
            const uniqueApprovalDataURLs: string[] = [];
            const seenApprovalUserIDs = new Set<string>();
            addPermitSpaceFormValues.name.forEach(
              (member: any, idx: number) => {
                const ref = permitApprovalRefs[idx];
                if (
                  ref?.current &&
                  !ref.current.isEmpty() &&
                  member.userID &&
                  !seenApprovalUserIDs.has(member.userID)
                ) {
                  uniqueApprovalDataURLs.push(ref.current.toDataURL());
                  seenApprovalUserIDs.add(member.userID);
                }
              }
            );
            setPermitSignatureDataUrl((prev: any) => ({
              ...prev,
              permitApproval: uniqueApprovalDataURLs,
            }));
          }
          if (permitClosureRefs.length > 0) {
            const uniqueClosureDataURLs: string[] = [];
            const seenClosureUserIDs = new Set<string>();
            addPermitSpaceFormValues.name.forEach(
              (member: any, idx: number) => {
                const ref = permitClosureRefs[idx];
                if (
                  ref?.current &&
                  !ref.current.isEmpty() &&
                  member.userID &&
                  !seenClosureUserIDs.has(member.userID)
                ) {
                  uniqueClosureDataURLs.push(ref.current.toDataURL());
                  seenClosureUserIDs.add(member.userID);
                }
              }
            );
            setPermitSignatureDataUrl((prev: any) => ({
              ...prev,
              permitClosure: uniqueClosureDataURLs,
            }));
          }

          // const allEnvUsers = [
          //   ...(formValues.teamMember1?.userID ? [formValues.teamMember1] : []),
          //   ...(formValues.teamMember2?.userID ? [formValues.teamMember2] : []),
          //   ...formValues.additionalTeamMembers,
          // ];

          // Find users present in both allEnvUsers and permitFileValues
          // const commonEnvPermitUsers = addPermitSpaceFormValues.name.filter(
          //   (user: any) =>
          //     allEnvUsers.some(
          //       (photoItem: any) => photoItem.userID === user.userID
          //     )
          // );
          // Combine all envEntrantTopmans into one object as requested
          const allEnvEntrantTopmans = {
            approvalOfPermit: [
              ...(envEntrantTopmans.teamMember1?.approvalOfPermit
                ? [
                    {
                      userID: formValues.teamMember1?.userID,
                      value: envEntrantTopmans.teamMember1.approvalOfPermit,
                    },
                  ]
                : []),
              ...(envEntrantTopmans.teamMember2?.approvalOfPermit
                ? [
                    {
                      userID: formValues.teamMember2?.userID,
                      value: envEntrantTopmans.teamMember2.approvalOfPermit,
                    },
                  ]
                : []),
              ...(envEntrantTopmans.additionalMembers?.approvalOfPermit?.length
                ? envEntrantTopmans.additionalMembers.approvalOfPermit.map(
                    (item: any, idx: number) => ({
                      userID: formValues.additionalTeamMembers?.[idx]?.userID,
                      value: item.value,
                    })
                  )
                : []),
            ],
            permitClosure: [
              ...(envEntrantTopmans.teamMember1?.permitClosure
                ? [
                    {
                      userID: formValues.teamMember1?.userID,
                      value: envEntrantTopmans.teamMember1.permitClosure,
                    },
                  ]
                : []),
              ...(envEntrantTopmans.teamMember2?.permitClosure
                ? [
                    {
                      userID: formValues.teamMember2?.userID,
                      value: envEntrantTopmans.teamMember2.permitClosure,
                    },
                  ]
                : []),
              ...(envEntrantTopmans.additionalMembers?.permitClosure?.length
                ? envEntrantTopmans.additionalMembers.permitClosure.map(
                    (item: any, idx: number) => ({
                      userID: formValues.additionalTeamMembers?.[idx]?.userID,
                      value: item.value,
                    })
                  )
                : []),
            ],
          };

          allEnvUSers.forEach((member: any) => {
            setAddPermitSpaceFormValues((prev: any) => {
              const approvalEntrantExists =
                prev.entrantTopmans.approvalOfPermit.some(
                  (item: any) => item.userID === member.userID
                );

              const approvalEnvValue =
                allEnvEntrantTopmans.approvalOfPermit.find(
                  (item: any) => item.userID === member.userID
                );
              const closureEntrantExists =
                prev.entrantTopmans.permitClosure.some(
                  (item: any) => item.userID === member.userID
                );
              const closureEnvValue = allEnvEntrantTopmans.permitClosure.find(
                (item: any) => item.userID === member.userID
              );
              return {
                ...prev,
                entrantTopmans: {
                  ...prev.entrantTopmans,
                  approvalOfPermit: approvalEntrantExists
                    ? prev.entrantTopmans.approvalOfPermit.map((item: any) =>
                        item.userID === member.userID
                          ? { ...item, value: approvalEnvValue?.value || "" }
                          : item
                      )
                    : [
                        ...prev.entrantTopmans.approvalOfPermit,
                        {
                          userID: member.userID,
                          value: approvalEnvValue?.value || "",
                        },
                      ],
                  permitClosure: closureEntrantExists
                    ? prev.entrantTopmans.permitClosure.map((item: any) =>
                        item.userID === member.userID
                          ? { ...item, value: closureEnvValue?.value || "" }
                          : item
                      )
                    : [
                        ...prev.entrantTopmans.permitClosure,
                        {
                          userID: member.userID,
                          value: closureEnvValue?.value || "",
                        },
                      ],
                },
              };
            });
          });

          setShowPermitSpaceFormPopup(false);
        }}
        modal
        className="tw-w-[1220px]"
        draggable={false}
        resizable={true}
      >
        <AddPermitSpaceEntryForm
          projectKeyName={formValues?.projectKeyName}
          formValues={addPermitSpaceFormValues}
          setFormValues={setAddPermitSpaceFormValues}
          isUploadInProgress={isUploadInProgress}
          setIsUploadInProgress={setIsUploadInProgress}
          images={permitImages}
          setImages={setPermitImages}
          fileValues={permitFileValues}
          setFileValues={setPermitFileValues}
          timeStampLocationValues={permitTimeStampLocationValues}
          setTimeStampLocationValues={setPermitTimeStampLocationValues}
          selectedDescriptionOfSurveySite={selectedDescriptionOfSurveySite}
          setSelectedDescriptionOfSurveySite={
            setSelectedDescriptionOfSurveySite
          }
          selectedPermitClosureReason={selectedPermitClosureReason}
          setSelectedPermitClosureReason={setSelectedPermitClosureReason}
          selectedPurposeOfEntry={selectedPurposeOfEntry}
          setSelectedPurposeOfEntry={setSelectedPurposeOfEntry}
          selectedNames={selectedNames}
          setSelectedNames={setSelectedNames}
          permitStartDateTime={permitStartDateTime}
          setPermitStartDateTime={setPermitStartDateTime}
          permitEndDateTime={permitEndDateTime}
          setPermitEndDateTime={setPermitEndDateTime}
          isPermitSpaceFormAttached={isPermitSpaceFormAttached}
          showAttachedFiles={permitSpaceFileValues}
          teamMember1={formValues?.teamMember1}
          teamMember2={formValues?.teamMember2}
          additionalTeamMembers={formValues?.additionalTeamMembers}
          signatureDataURLs={signatureDataURLs}
          envEntrantTopmans={envEntrantTopmans}
          setEnvEntrantTopmans={setEnvEntrantTopmans}
          permitSignatureFiles={permitSignatureFiles}
          setPermitSignatureFiles={setPermitSignatureFiles}
        />
      </Dialog>
    </>
  );
};

export default AddEnvironmentalSurveying;
